import { Component, OnInit, Inject } from '@angular/core';
import { AccountService } from '../../../../../services/account.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CorporateService } from 'src/app/services/corporate.service';

@Component({
  selector: 'app-edit-license-dialog',
  templateUrl: './edit-license-dialog.component.html',
  styleUrls: ['./edit-license-dialog.component.css']
})
export class EditLicenseDialogComponent implements OnInit {
  api_error: any;
  api_success: string;
  disableConfirmbtn = false;
  licensePackages: any = [];
  licenseSelected;
  currentLicense: any;
  downGradedLicenseId: any;

  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: number,
    private accountService: AccountService,
    private corporateService: CorporateService) { }
  ngOnInit() {

    this.accountService.getLicensePackages()
      .subscribe(res => {
        this.licensePackages = res;

      });
    this.currentLicense = this.data['licensedetails'];
    console.log('currentLicense......... ' + JSON.stringify(this.currentLicense));
    // tslint:disable-next-line:triple-equals
    if (this.data['type'] == 'account') {
    this.licenseSelected = this.currentLicense.licPkgOrAddonId;
    // tslint:disable-next-line:triple-equals
    } else if (this.data['type'] == 'corporate') {
      this.licenseSelected = this.currentLicense.licPkg;
    }
    console.log('licenseSelected......... ' + this.licenseSelected);
    this.downGradedLicenseId = this.data['downgradeLicense'];
  }
  makeDisable(pkgId) {
    if (this.currentLicense.licPkgOrAddonId === pkgId) {
      return true;
    } else if (this.downGradedLicenseId === pkgId) {
      return true;
    } else {
      return false;
    }
  }
  updateLicense() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    // tslint:disable-next-line:triple-equals
    if (this.data['type'] == 'account') {
      const dataObj = {
        'accountId': this.data['accountId'],
        'licensePackageId': this.licenseSelected
      };
      this.accountService.updateLicense(dataObj)
      .subscribe(
        data => {
          this.api_success = 'License updated Successfully';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
          }, 2000);
        },
        (error) => {
          this.api_error = error.error;
          this.disableConfirmbtn = false;
        }
      );

    // tslint:disable-next-line:triple-equals
    } else if (this.data['type'] == 'corporate') {
      this.corporateService.updateLicense(this.data['corpId'], this.licenseSelected)
      .subscribe(
        data =>  { 
          this.api_success = 'License updated Successfully';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
          }, 2000);
        },
        (error) => {
          this.api_error = error.error;
          this.disableConfirmbtn = false;
        }
      );

    }

  }
  public closeDialog() {
    this.dialogRef.close();
  }

}
